import UAParser from 'ua-parser-js';
const uaparser = new UAParser();

function isSafari() {
  const isSafari = uaparser.getBrowser().name.toLowerCase().includes('safari');
  return isSafari;
}

export {
  isSafari
}
